export default __webpack_public_path__ + "static/media/11.7836e51a.png";